module.exports = __webpack_public_path__ + "img/existing-resources-3-2.717b7f48.jpg";